import iryna from '../../images/teams/iryna-bodnaryuk.jpg';
import vladyslavGladyshko from '../../images/teams/vladyslav-gladyshko.jpg';
import yuriy from '../../images/teams/yuriy_kulinichenko.jpg';
import oleksandr from '../../images/teams/aleksandr-kurzhiy.jpg';
import andrey from '../../images/teams/andrey-dymov.jpg';
import rustem from '../../images/teams/rustem-dzhuraiev.jpg';
import vladyslavZavertaylo from '../../images/teams/vladislav-zavertaylo.jpg';
import vladyslavStepanov from '../../images/teams/vladyslav.jpg';
import roman from '../../images/teams/roman-tunkiv.jpg';
import serhiy from '../../images/teams/serhiy-nazarov.jpg';

export const teamItems = [
  {
    img: vladyslavGladyshko,
    name: 'Vladyslav',
    role: 'Team Lead',
    git: 'https://github.com/ImVladislav',
  },
  {
    img: iryna,
    name: 'Iryna',
    role: 'Scrum Master',
    git: 'https://github.com/Irka-Bodnariuk',
  },
  {
    img: yuriy,
    name: 'Yuriy',
    role: 'Developer',
    git: 'https://github.com/yurakulinichenko',
  },
  {
    img: oleksandr,
    name: 'Oleksandr',
    role: 'Developer',
    git: 'https://github.com/voanergesKM',
  },
  {
    img: andrey,
    name: 'Andrey',
    role: 'Developer',
    git: 'https://github.com/Heyswor',
  },
  {
    img: vladyslavZavertaylo,
    name: 'Vladyslav',
    role: 'Developer',
    git: 'https://github.com/vladislavzaver91',
  },
  {
    img: rustem,
    name: 'Rustem',
    role: 'Developer',
    git: 'https://github.com/RustDzhur',
  },
  {
    img: vladyslavStepanov,
    name: 'Vladyslav',
    role: 'Developer',
    git: 'https://github.com/Vlad7Stepanov7',
  },
  {
    img: roman,
    name: 'Roman',
    role: 'Developer',
    git: 'https://github.com/skif6623',
  },
  {
    img: serhiy,
    name: 'Serhiy',
    role: 'Developer',
    git: 'https://github.com/SerhiiNazarov',
  },
];
